import { useCurrentUser } from 'user/hooks/useCurrentUser'

import { useSelector } from 'react-redux'
import { profileSettingsSlice } from '../../slices/profileSettingsSlice'
import { userSettingsKeys } from '../data'
import { useGetApiV1SettingsUserQuery } from '../../api'

export const useProfileSettings = () => {
  const { isLogged } = useCurrentUser()

  const { isLoading: isFetching } = useGetApiV1SettingsUserQuery(
    {
      keys: userSettingsKeys,
    },
    {
      skip: !isLogged,
    },
  )

  const settings = useSelector(
    profileSettingsSlice.selectors.selectProfileSettings,
  )

  return { settings, isLoading: isFetching, isSuccess: !isFetching }
}
